<template>
  <div class="por-cartao">
    <div class="row">
      <PublicHeader title="Pesquisa por Nº SUS">
        <div class="col-xs-12">
          <p>
            Aqui você encontra seu histórico de atendimentos e suas solicitações
            de consultas e exames.
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="container">
      <Breadcrumb :links="breadcrumb" />
      <section class="border-bottom">
        <header>
          <h2>Solicitações de agendamento</h2>
        </header>
        <CardFilaEspera
          :carregando="carregando.especialidades"
          :title="'Consultas'"
          :items="listaEspecialidades"
          :chave="'especialidade'"
        />
        <CardFilaEspera
          :carregando="carregando.exames"
          :title="'Exames'"
          :items="listaExames"
          :chave="'exame'"
        />
        <!-- <div class="row margem-bottom">
          <div class="col-xs-12">
            <h3>Tempo médio para agendamento</h3>
            <div v-if="mediaEspera.especialidades.length">
              <div
                v-for="item in mediaEspera.especialidades"
                :key="`esp-${item.especialidades}`"
              >
                <span class="destaque">{{ item.especialidade }}:</span>
                <span class="font-lg">
                  {{ Number(item.media).toFixed(0) }} dias
                </span>
              </div>
            </div>
            <div v-if="mediaEspera.exames.length">
              <div
                v-for="item in mediaEspera.exames"
                :key="`esp-${item.exame}`"
              >
                <span class="destaque">{{ item.exame }}:</span>
                <span class="font-lg">
                  {{ Number(item.media).toFixed(0) }} dias
                </span>
              </div>
            </div>
            <div
              v-if="carregando.mediaexames || carregando.mediaespecialidades"
              class="row"
            >
              <div class="col-xs-12 font-lg">
                <font-awesome-icon :icon="'spinner'" spin />
              </div>
            </div>
            <div
              class="row"
              v-if="
                !carregando.mediaexames &&
                  !carregando.mediaespecialidades &&
                  !mediaEspera.exames.length &&
                  !mediaEspera.especialidades.length
              "
            >
              <div class="col-xs-12">
                <p class="font-lg">Nenhum item encontrado</p>
              </div>
            </div>
          </div>
        </div> -->
        <p class="font-lg">
          Para mais informações, ligue na central de agendamento
          <span class="destaque">(0800-013-0013)</span>
        </p>
      </section>
      <section class="border-bottom">
        <header>
          <h2>Agendados</h2>
        </header>
        <ListaFilaAgendados
          :carregando="carregando.especialidadesAgendados"
          :items="listaEspecialidadesAgendadas"
          :title="'Consultas'"
          :chave="'especialidade'"
        />
        <ListaFilaAgendados
          :carregando="carregando.examesAgendados"
          :items="listaExamesAgendados"
          :title="'Exames'"
          :chave="'exame'"
        />
      </section>
      <section>
        <header>
          <h2>Meu histórico de saúde</h2>
        </header>
        <ListaFilaAgendados
          :carregando="carregando.especialidadesAgendados"
          :items="listaEspecialidadesConcluidas"
          :title="'Consultas'"
          :chave="'especialidade'"
        />
        <ListaFilaAgendados
          :carregando="carregando.examesAgendados"
          :items="listaExamesConcluidos"
          :title="'Exames'"
          :chave="'exame'"
        />
      </section>
    </div>
  </div>
</template>

<script>
import {
  Breadcrumb,
  ListaFilaAgendados,
  CardFilaEspera,
  PublicHeader
} from '../../../components'
import { request } from '../../../request'

export default {
  components: { PublicHeader, Breadcrumb, CardFilaEspera, ListaFilaAgendados },
  data() {
    return {
      carregando: {
        especialidades: false,
        exames: false,
        especialidadesAgendados: false,
        examesAgendados: false,
        mediaespecialidades: false,
        mediaexames: false
      },
      especialidades: [],
      exames: [],
      mediaEspera: {
        exames: [],
        especialidades: []
      },
      especialidadesAgendados: [],
      examesAgendados: [],
      cartao: '',
      breadcrumb: [
        {
          label: 'Minha Saúde',
          named_link: { name: 'procedimentos_saude' }
        },
        {
          label: ''
        }
      ],
      urls: {
        especialidadesEspera: 'procedimentos-saude/lista-especialidades',
        especialidadesAgendados:
          'procedimentos-saude/lista-especialidades-agendados',
        examesEspera: 'procedimentos-saude/lista-exames',
        examesAgendados: 'procedimentos-saude/lista-exames-agendados'
      },
      dataAtual: new Date().setHours(0, 0, 0, 0)
    }
  },
  created() {
    const { cartao } = this.$route.params

    if (!cartao) {
      return this.$router.push({ name: 'procedimentos_saude' })
    }

    this.cartao = cartao
    this.breadcrumb[1].label = `Nº SUS: ${cartao}`

    this.getLista(this.urls.especialidadesEspera, 'especialidades')
    this.getLista(this.urls.examesEspera, 'exames')
    this.getLista(this.urls.especialidadesAgendados, 'especialidadesAgendados')
    this.getLista(this.urls.examesAgendados, 'examesAgendados')
  },
  methods: {
    toggleLoading(key) {
      this.carregando[key] = !this.carregando[key]
    },
    getLista(url, key) {
      this.toggleLoading(key)
      request
        .get(url, {
          params: {
            cartao: this.cartao,
            order: 'desc'
          }
        })
        .then(response => {
          const { data } = response

          this[key] = data
        })
        .catch(error => {
          console.log(error.response)
          this.$toastr.e(
            'Houve um errro ao carregar a lista. Atualize a página e tente novamente'
          )
        })
        .finally(() => this.toggleLoading(key))
    },
    checkIfDateLowerThanNow(date) {
      const dataAgendada = new Date(date)
      return dataAgendada < this.dataAtual
    },
    getTempoMediaEspera(key, lista) {
      if (lista.length) {
        this.toggleLoading(`media${key}`)
        request
          .get(`procedimentos-saude/${key}/media-dias`, {
            params: {
              [key]: lista
            }
          })
          .then(response => {
            const { data } = response
            this.mediaEspera[key] = data
          })
          .catch(error => {
            this.$toastr.e(
              'Houve um erro ao calcular o tempo médio para agendamento. Tente novamente mais tarde'
            )
          })
          .finally(() => {
            this.toggleLoading(`media${key}`)
          })
      }
    }
  },
  watch: {
    exames(newValue) {
      const exames = newValue.map(item => {
        return item.exame
      })

      this.getTempoMediaEspera('exames', exames)
    },
    especialidades(newValue) {
      const especialidades = newValue.map(item => {
        return item.especialidade
      })

      this.getTempoMediaEspera('especialidades', especialidades)
    }
  },
  computed: {
    listaEspecialidades() {
      return this.especialidades
    },
    listaExames() {
      return this.exames
    },
    listaEspecialidadesAgendadas() {
      const filter = item => {
        return !this.checkIfDateLowerThanNow(item.dtagendamento)
      }

      return this.especialidadesAgendados.filter(filter)
    },
    listaEspecialidadesConcluidas() {
      const filter = item => {
        return this.checkIfDateLowerThanNow(item.dtagendamento)
      }

      return this.especialidadesAgendados.filter(filter)
    },
    listaExamesAgendados() {
      const filter = item => {
        return !this.checkIfDateLowerThanNow(item.dtagendamento)
      }

      return this.examesAgendados.filter(filter)
    },
    listaExamesConcluidos() {
      const filter = item => {
        return this.checkIfDateLowerThanNow(item.dtagendamento)
      }

      return this.examesAgendados.filter(filter)
    }
  }
}
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #697473;
}
</style>



// WEBPACK FOOTER //
// src/views/public/procedimentos_saude/PorCartaoSUS.vue